import React from "react";
import moment from 'moment';

export const formFields = {
  advertiserId: {
    key: 'advertiserId',
    label: 'Advertiser',
    required: true,
    placeholder: '',
    requiredMessage: 'This field is required.',
    displayLayout: 'col-md-12',
    valueKey: 'key',
    textKey: 'value',
    tooltip: '<div> Advertiser </div>'
  },
  roName: {
    key: 'roName',
    type: 'text',
    label: 'Goal Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 characters allowed.',
    maxLength: 100,
    maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    labelLayout: 'py-1',
    tooltip: '<div> RO Name </div>',
    pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    patternMessage: 'Goal Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },


  campaigncategory: {
    key: 'campaigncategory',
    label: 'Category ',
    placeholder: '',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'text',
  },
  subCampaigncategory: {
    key: 'subCampaigncategory',
    label: 'Sub-Category ',
    placeholder: '',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'text',
  },
  primaryGoal: {
    key: 'primaryGoal',
    label: 'Primary Goal',
    placeholder: '',
    required: true,
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
    valueKey: 'key',
    textKey: 'value',
  },
  targetValuePrimary: {
    key: 'targetValuePrimary',
    type: 'number',
    label: 'Primary Goal Value',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    minLengthMessage: 'Minimum value is 0.',
    // maxLength: 100,
    min:0,
    upto2Digit:true,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
  tolerancePrimary: {
    key: 'tolerancePrimary',
    type: 'number',
    label: 'Tolerance %',
    placeholder: '',
    required: false,
    requiredMessage: 'This field is required.',
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Tolerance % </div>',
    pattern: /^\d+(\.\d{1,2})?$/
  },

  secondryGoal: {
    key: 'secondryGoal',
    label: 'Secondry Goal',
    placeholder: '',
    required: false,
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
    valueKey: 'key',
    textKey: 'value',
  },
  targetValueSecondry: {
    key: 'targetValueSecondry',
    type: 'number',
    label: 'Secondary Goal Value',
    placeholder: '',
    required: false,
    requiredMessage: 'This field is required.',
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    // maxLength: 100,
    min:0,
    upto2Digit:true,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },

  toleranceSecondry: {
    key: 'toleranceSecondry',
    type: 'number',
    label: 'Tolerance %',
    placeholder: '',
    required: false,
    requiredMessage: 'This field is required.',
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Tolerance % </div>',
    pattern: /^\d+(\.\d{1,2})?$/
  },
  
  status: {
    key: 'status',
    label: 'Status',
    placeholder: '',
    required: true,
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
    valueKey: 'key',
    textKey: 'value',
  },


  // budget: {
  //   key: 'budget',
  //   type: 'number',
  //   label: 'Budget',
  //   placeholder: '',
  //   required: true,
  //   requiredMessage: 'This field is required.',
  //   minLength: 1,
  //   // min: 0,
  //   // max: 9999999,
  //   minLengthMessage: 'Minimum 1 numbers allowed.',
  //   maxLength: 7,
  //   maxLengthMessage: 'maximum 7 numbers allowed.',
  //   displayLayout: 'col-md-12',
  //   tooltip: '<div> IO Budget </div>'
  // },

  // dspPlatform: {
  //   key: 'dspPlatform',
  //   type: 'text',
  //   label: 'DSP Platform',
  //   placeholder: '',
  //   required: true,
  //   requiredMessage: 'This field is required.',
  //   minLength: 3,
  //   // minLengthMessage: 'Minimum 3 charactors allowed.',
  //   maxLength: 100,
  //   // maxLengthMessage: 'maximum 100 characters allowed.',
  //   displayLayout: 'col-md-12',
  //   tooltip: '<div> DSP Platform </div>',
  //   // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  // },

  // campaignName: {
  //   key: 'campaignName',
  //   type: 'text',
  //   label: 'Campaign Name',
  //   placeholder: '',
  //   required: true,
  //   requiredMessage: 'This field is required.',
  //   minLength: 3,
  //   // minLengthMessage: 'Minimum 3 charactors allowed.',
  //   maxLength: 100,
  //   // maxLengthMessage: 'maximum 100 characters allowed.',
  //   displayLayout: 'col-md-12',
  //   tooltip: '<div> Campaign Name </div>',
  //   // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  // },

  thumbnailUrl: {
    key: 'thumbnailUrl',
    label: 'Upload ICON Image',
    required: false,
    placeholder: 'Upload ICON Image',
    displayLayout: 'col-md-7',
    uploadRequired: false,
    requiredMessage: 'Upload ICON Image is required.',
    uploadMessage: 'Please Upload ICON Image.',
    tooltip: '<div>Upload ICON Image</div>',
    maxLength: 4000,
    maxLengthMessage: 'maximum 4000 characters allowed.'
  },

  url: {
    key: 'url',
    type: 'file',
    label: 'Creative',
    placeholder: '',
    required: false,
    requiredMessage: 'This field is required.',
    minLength: 3,
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Creative </div>',
    // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  },

  startDate: {
    key: 'startDate',
    label: 'Start Date',
    required: false,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    label: 'End Date',
    required: false,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

};

export const confirmationMessage = {
  action: {
    confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
    type: 'Confirmation'
  }
}

export const successfullyMessage = {
  action: {
    confirmationMessage: 'Successfully Saved RO Details',
    type: 'Success',
  }
}

export const Goal = [
  { key: '1', value: 'CPM' },
  { key: '2', value: 'Clicks' },
  { key: '3', value: 'CPC' },
  { key: '4', value: 'CTR' },
  { key: '5', value: 'VCR' },
  { key: '6', value: 'CPA / CPL' },
  { key: '7', value: 'VTR' },
]
export const roStaus = [
  { key: '1', value: 'Active' },
  { key: '0', value: 'Inactive' },
]


export const campaignOptions = {
  columns: [
    { id: 1, name: 's.no', label: 'S.No.', sortable: false, type: 'number', expand: true }, 
    { id: 2, name: 'name', label: 'Campaign Name', sortable: true, type: 'string',component: (row) => <div title={row.name}>{row.name.length > 58 ? `${row.name.slice(0,58)} ...`: row.name }</div>},
    { id: 3, name: 'mapDate', label: 'Mapped On', sortable: false, type: 'string',component: (row) => row.mapDate != undefined ? moment(row.mapDate).format("YYYY-MM-DD") : "-" },
    { id: 4, name: 'url', label: 'Dashboard Thumbnail', sortable: false, type: 'string', component: (row) =>row.url},
    { id: 5, name: 'status', label: 'Status', sortable: false, type: 'string', component: (row) => row.status == 1 ? <p className='badge bg-label-success'>Active</p> : <p className='badge bg-label-danger'>Inactive</p> },
  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-delete',
    tooltip: 'Edit'
  },
  ],
  // recActive: true,
  // status: {
  //   key: 'status',
  //   active: '1',
  //   activeIcon: 'mdi mdi-checkbox-marked',
  //   inActiveIcon: 'mdi mdi-close-box',
  //   confirmation: true,
  //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
  //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  // },
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};